import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export interface RangePlanBarcodeActionAccepted {
  code?: number;
  data?: { queued?: number };
}

export const assignRangePlanRetailBarcodes = (
  devOrderIds: string[],
  barcodeType: string,
): Promise<RangePlanBarcodeActionAccepted> =>
  apiClient.post(`${apiEndpoint}${API.RANGE_PLAN_IDENTIFIER_BARCODES.RETAIL}`, { devOrderIds, barcodeType });

export const generateRangePlanGtin14 = (
  devOrderIds: string[],
  factorIndicatorId: string,
): Promise<RangePlanBarcodeActionAccepted> =>
  apiClient.post(`${apiEndpoint}${API.RANGE_PLAN_IDENTIFIER_BARCODES.GTIN14}`, { devOrderIds, factorIndicatorId });
